import styled from 'styled-components';

export const Wrapper = styled.div`

    form ._2lUSM {
      margin-bottom:15px;
      
    } 
    .mensaje {
      margin-bottom: 20px;
  }
    .horario {
      margin-bottom: 24px;
  } 
    .horario b {
    font-size: 1.5rem;
    line-height: 1.5;
  }
    .horario p {
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 400;
  }
 
    .mensajeInfo {
    margin-bottom: 20px;
    margin-top: 20px;
  }
    .contenedor {
    display: grid;
    grid-template-columns: 1fr;
    text-align: center;
    gap: 32px;
  } 
  .info .p-mensaje {
    font-weight: bold;
    line-height: 19px;
}
    .info .p-coment{
      margin-top: 4px;
    }


    
   
`;

export default Wrapper;